export default "__VITE_ASSET__Dyygjyz1__"